import { useState } from "react";
import { Card, PageHeader } from "../../components/shared/UIComponents";
import { AdminMgmtAPI } from "../../services/api";
import { useAsyncData } from "../../hooks/useAsyncData";

export function SAList({ onEdit }) {
  const { data: admins, loading, error, reload } = useAsyncData(() => AdminMgmtAPI.getAll());
  const [search, setSearch] = useState("");
  const filt = admins.filter(a => !search || [a.name,a.email,a.society,a.city].some(v=>String(v||"").toLowerCase().includes(search.toLowerCase())));

  const toggleStatus = async (admin) => {
    try {
      await AdminMgmtAPI.updateStatus(admin.id, { active: !(admin.active ?? admin.status === "Active") });
      reload();
    } catch(e) { alert(e.message); }
  };

  const handleDelete = async (id) => {
    if (!window.confirm("Delete this admin?")) return;
    try { await AdminMgmtAPI.delete(id); reload(); }
    catch(e) { alert(e.message); }
  };

  return (
    <Card>
      <PageHeader title="All Admins" sub={`${admins.length} total registered`} />
      <div style={{ padding:"0 20px 20px" }}>
        <div style={{ display:"flex", justifyContent:"space-between", marginBottom:14, alignItems:"center", flexWrap:"wrap", gap:10 }}>
          <div style={{ display:"flex", gap:8 }}>
            <span style={{ background:"#e6f4ea", color:"#0f9d58", padding:"4px 10px", borderRadius:20, fontWeight:600, fontSize:12 }}>Active: {admins.filter(a=>a.active!==false&&a.status!=="Inactive").length}</span>
            <span style={{ background:"#fce8e6", color:"#d32f2f", padding:"4px 10px", borderRadius:20, fontWeight:600, fontSize:12 }}>Inactive: {admins.filter(a=>a.active===false||a.status==="Inactive").length}</span>
          </div>
          <input value={search} onChange={e=>setSearch(e.target.value)} placeholder="Search admins…"
            style={{ padding:"8px 12px", border:"1.5px solid #e0e0e0", borderRadius:8, fontSize:13, outline:"none", width:200 }} />
        </div>
        {loading && <div style={{ padding:30, textAlign:"center", color:"#78909c" }}>Loading…</div>}
        {error   && <div style={{ padding:16, color:"#c62828" }}>Error: {error}</div>}
        {!loading && (
          <div style={{ overflowX:"auto" }}>
            <table style={{ width:"100%", borderCollapse:"collapse", fontSize:13 }}>
              <thead>
                <tr style={{ background:"#f5f7fa" }}>
                  {["#","Name","Email","Phone","Society","City","Status","Actions"].map(h=>(
                    <th key={h} style={{ padding:"10px 12px", textAlign:"left", fontWeight:600, color:"#546e7a", fontSize:11, textTransform:"uppercase", borderBottom:"2px solid #e8eaf0" }}>{h}</th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {filt.length === 0 && <tr><td colSpan={8} style={{ padding:30, textAlign:"center", color:"#90a4ae" }}>No admins found.</td></tr>}
                {filt.map((a, i) => {
                  const active = a.active !== false && a.status !== "Inactive";
                  return (
                    <tr key={a.id} style={{ borderBottom:"1px solid #f0f2f5" }}
                      onMouseEnter={e=>e.currentTarget.style.background="#fafbfc"}
                      onMouseLeave={e=>e.currentTarget.style.background=""}>
                      <td style={{ padding:"10px 12px", color:"#90a4ae" }}>{i+1}</td>
                      <td style={{ padding:"10px 12px", fontWeight:600, color:"#263238" }}>
                        <div style={{ display:"flex", alignItems:"center", gap:8 }}>
                          <div style={{ width:30, height:30, borderRadius:"50%", background:`hsl(${(a.id||1)*80},60%,45%)`, display:"flex", alignItems:"center", justifyContent:"center", fontSize:12, color:"#fff", fontWeight:700, flexShrink:0 }}>{(a.name||"A")[0]}</div>
                          {a.name}
                        </div>
                      </td>
                      <td style={{ padding:"10px 12px", color:"#546e7a" }}>{a.email}</td>
                      <td style={{ padding:"10px 12px", color:"#546e7a" }}>{a.phone||"—"}</td>
                      <td style={{ padding:"10px 12px" }}>{a.society||"—"}</td>
                      <td style={{ padding:"10px 12px" }}>{a.city||"—"}</td>
                      <td style={{ padding:"10px 12px" }}>
                        <span style={{ padding:"3px 10px", borderRadius:20, fontSize:11, fontWeight:700, background:active?"#e6f4ea":"#fce8e6", color:active?"#0f9d58":"#d32f2f" }}>{active?"Active":"Inactive"}</span>
                      </td>
                      <td style={{ padding:"10px 12px" }}>
                        <div style={{ display:"flex", gap:6 }}>
                          <button onClick={()=>onEdit&&onEdit(a)} style={{ padding:"5px 10px", background:"#e3f2fd", border:"none", borderRadius:6, cursor:"pointer", color:"#1565c0", fontSize:12, fontWeight:500 }}>Edit</button>
                          <button onClick={()=>toggleStatus(a)} style={{ padding:"5px 10px", background:active?"#fff3e0":"#e8f5e9", border:"none", borderRadius:6, cursor:"pointer", color:active?"#e65100":"#2e7d32", fontSize:12, fontWeight:500 }}>{active?"Deactivate":"Activate"}</button>
                          <button onClick={()=>handleDelete(a.id)} style={{ padding:"5px 10px", background:"#fce8e6", border:"none", borderRadius:6, cursor:"pointer", color:"#c62828", fontSize:12, fontWeight:500 }}>Delete</button>
                        </div>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </Card>
  );
}

export default SAList;
